import JobApplicationForm from './JobApplicationForm.component';

export default JobApplicationForm;
